import React, { Component } from "react";
import {
  Input,
  Button,
  Table,
  Row,
  Col
} from "reactstrap";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import CcCheckbox from "../../../../03-components/ccCheckbox";
import {
  getChargeRequest,
  rejectCharge,
  approvalCharge,
  chargeSearch
} from "../../../../01-actions/charge";
import "./style.css";
import {GE_TOP_UP_STATUS, STATUS_CHARGE} from "../../../../05-utils/commonData";
import { formatDateTimeFull } from "../../../../05-utils/commonUtils";
import ReactPaginate from "react-paginate";
import { ACTIONS } from "../../../../01-actions/charge";
import { CircularProgress } from "@material-ui/core";
import Alert from "../../../../03-components/Alert";
import moment from "moment";
import _ from "lodash";
import Workbook from "react-excel-workbook";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class ChargeRequestList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 100,
      activePage: 1,
      charges: props.charges,
      tickCharges: [],
      startTime: null,
      endTime: null,
      filterBy: "",
      businessId: null,
      keyWord: "",
      checkDate: false,
      isReBalance: false,
      isReject: false,
      groupId: props.location.search.split("=")[
        props.location.search.split("=").length - 1
      ],
      loading: true
    };
    // this.handleChangeStartTime = this.handleChangeStartTime.bind(this);
    // this.handleChangeEndTime = this.handleChangeEndTime.bind(this);
  }

  alertAck = () => {
    this.setState({ alertAck: false });
  };

  componentDidMount() {
    const { groupId } = this.state;
    this.props.handleGetChargeRequest({
      limit: this.state.limit,
      page: this.state.activePage,
      status: STATUS_CHARGE.INIT,
      businessId: groupId ? groupId : null
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.charges !== this.state.charges) {
      this.setState({
        charges: _.orderBy(nextProps.charges, ["timestamps"], ["asc"])
      });
    }
  }

  handleChange = name => e => {
    this.setState(
      {
        [name]: e.target.value
      },
      () => {
        this.validateDate();
      }
    );
  };

  handleChangeStartTime = date => {
    this.setState({
      startTime: date
    });
  };

  handleChangeEndTime = date => {
    this.setState({
      endTime: date
    });
  };

  validateDate() {
    let checkData = moment(this.state.startTime) > moment(this.state.endTime);
    this.setState({ checkDate: checkData });
  }

  handleSearchData = () => {
    this.alertAck();
    const { filterBy } = this.state;
    let query = null;
    if (filterBy) {
      switch (filterBy) {
        case "Business Member Id":
          query = { businessMemberId: { $regex: this.state.keyWord } };
          break;
        case "GBT greater":
          query = { GBTAmount: { $gt: this.state.keyWord } };
          break;
        case "GBT greater or equal":
          query = { GBTAmount: { $gte: this.state.keyWord } };
          break;
        case "GBT smaller":
          query = { GBTAmount: { $lt: this.state.keyWord } };
          break;
        case "GBT smaller or equal":
          query = { GBTAmount: { $lte: this.state.keyWord } };
          break;
        case "Full Name":
          query = { fullname: { $regex: this.state.keyWord } };
          break;
        default:
          break;
      }
    } else query = "";
    this.props.chargeSearch({
      startTime: this.state.startTime,
      endTime: this.state.endTime,
      query: query,
      page: 1,
      status: STATUS_CHARGE.INIT,
      businessId: this.state.businessId
    });
  };

  handlePageClick = data => {
    const page = data.selected + 1;
    this.setState({ activePage: page }, () => {
      this.props.handleGetChargeRequest({
        limit: this.state.limit,
        page: this.state.activePage,
        status: STATUS_CHARGE.INIT
      });
    });
  };

  handleCheckboxAllChange() {
    return e => {
      // let charges = [...this.state.charges].filter(val => val.passportNumber);
      let charges = [...this.state.charges].filter(val => (
        val.passportNumber && val.businessId !== '03') || val?.extra?.topUpStatus !== +Object.keys(GE_TOP_UP_STATUS)[1]
      );
      let tickAllCharge = [...this.state.charges].map(user =>
        Object.assign({}, user, {
          isChecked: user.passportNumber ? e.target.checked : false
        })
      );
      let chargeIds = e.target.checked
        ? [...charges].map(charge => charge._id)
        : [];
      this.setState({ charges: tickAllCharge, tickCharges: chargeIds });
    };
  }

  handleCheckboxChange(e, data, index) {
    let indexCharge = [...this.state.tickCharges].indexOf(data._id);
    let charges =
      indexCharge < 0
        ? [...this.state.tickCharges, data._id]
        : [...this.state.tickCharges].filter(item => item !== data._id);
    this.setState({
      tickCharges: charges,
      charges: [
        ...this.state.charges.slice(0, index),
        { ...this.state.charges[index], isChecked: e.target.checked },
        ...this.state.charges.slice(index + 1)
      ]
    });
  }

  handleSelectGroupChange = value => {
    if (value !== "00") {
      this.props.history.push({
        pathname: "/charged-request-list",
        search: `?group=${value}`
      });
      this.setState({
        businessId: value
      });
      this.props.handleGetChargeRequest({
        limit: this.state.limit,
        page: this.state.activePage,
        status: STATUS_CHARGE.INIT,
        businessId: value
      });
    } else {
      this.props.history.push(`/charged-request-list`);
      this.setState({
        businessId: null
      });
      this.props.handleGetChargeRequest({
        limit: this.state.limit,
        page: this.state.activePage,
        status: STATUS_CHARGE.INIT
      });
    }
  };

  renderHeaderTable() {
    const { t } = this.props;
    return (
      <tr className="tb-header">
        <th className="custom-item-no-border">
          <CcCheckbox onChange={this.handleCheckboxAllChange()}/>
        </th>
        <th className="custom-item">{t("TopUpPage.Table.No")}</th>
        <th>{t("TopUpPage.Table.BusinessMemberId")}</th>
        <th>{t("TopUpPage.Table.PassportNumber")}</th>
        <th>{t("TopUpPage.Table.FullName")}</th>
        <th>{t("TopUpPage.Table.GBTAmount")}</th>
        <th>{t("TopUpPage.Table.TopUpAmount")}</th>
        <th>{t("TopUpPage.Table.GBTExcelFinanceFee")}</th>
        <th>{t("TopUpPage.Table.GBTEzpFee")}</th>
        <th>{t("TopUpPage.Table.CreatedAt")}</th>
        <th>{t("TopUpPage.Table.TimesRequestInDay")}</th>
        <th>{t("TopUpPage.Table.TimesRequestInMonth")}</th>
        <th>{t("TopUpPage.Table.Status")}</th>
      </tr>
    );
  }

  renContentTable() {
    const { t } = this.props;
    if (Array.isArray(this.state.charges) && this.state.charges.length > 0) {
      return (
        <tbody>
          {this.state.charges.map((item, index) => {
            return (
              <tr key={index} className="tb-body">
                <td className="check-box">
                  {((item.passportNumber && item.businessId !== '03') || item.extra?.topUpStatus !== +Object.keys(GE_TOP_UP_STATUS)[1]) && (
                    <CcCheckbox
                      checked={item.isChecked || false}
                      value={item.isChecked || false}
                      className="check-box-item"
                      onChange={e => this.handleCheckboxChange(e, item, index)}
                    />
                  )}
                </td>
                <td>{index + 1}</td>
                <td>{item.businessMemberId}</td>
                <td>{item.passportNumber}</td>
                <td>{item.fullname}</td>
                <td>{item.GBTAmount}</td>
                <td>{item.topUpAmount}</td>
                <td>{item.excelFeeGBT}</td>
                <td>{item.ezpFeeGBT}</td>
                <td>{formatDateTimeFull(item.timestamps)}</td>
                <td>{item.dayCharge}</td>
                <td>{item.monthCharge}</td>
                {
                  item.businessId === '03' &&
                  <td>{item.extra && GE_TOP_UP_STATUS[item.extra?.topUpStatus || 0]}</td>
                }
              </tr>
            );
          })}
        </tbody>
      );
    } else {
      return (
        <tbody>
          <tr>
            <td className="custom-checkbox-no-border"></td>
            <td colSpan={11}>
              <div className="d-flex justify-content-center">
                <span>{t("NoDataToShow")}</span>
              </div>
            </td>
          </tr>
        </tbody>
      );
    }
  }

  renderTable() {
    if (Array.isArray(this.state.charges) && this.state.charges.length > 9) {
      return (
        <div className="table-container">
          <Table striped size="sm">
            <thead className="thead-light">{this.renderHeaderTable()}</thead>
            {this.renContentTable()}
          </Table>
        </div>
      );
    } else {
      return (
        <Table responsive striped size="sm">
          <thead className="thead-light">{this.renderHeaderTable()}</thead>
          {this.renContentTable()}
        </Table>
      );
    }
  }

  render() {
    const { t } = this.props;
    const {
      startTime,
      endTime,
      checkDate,
      charges,
      tickCharges,
      groupId
    } = this.state;
    return (
      <div className="charge-request-list">
        <div className="title">
          <div className="title-content">
            {t("TopUpPage.ChargeApplicationList")}
          </div>
        </div>
        <div className="charge-request-list-content">
          <Row className="mt-3">
            <Col lg="3" md="3" sm="3" xs="12" className="mt-1">
              <Input
                className="selectGroup"
                type="select"
                name="selectGroup"
                id="selectGroup"
                defaultValue={groupId}
                onChange={event => {
                  this.handleSelectGroupChange(event.target.value);
                }}
              >
                <option value="00">{t("TopUpPage.GroupSelection")}</option>
                <option value="01">Greenbox</option>
                <option value="02">Triple</option>
                <option value="03">Huv Style</option>
              </Input>
            </Col>
          </Row>
          <Row>
            <Col lg="3" md="3" sm="3" xs="12" className="mt-1">
              <DatePicker
                className="form-control brs"
                placeholderText="YYYY-MM-DD"
                dateFormat="yyyy/MM/dd"
                selected={startTime}
                onChange={this.handleChangeStartTime}
              />
            </Col>
            <Col lg="3" md="3" sm="3" xs="12" className="mt-1">
              <DatePicker
                className="form-control brs"
                placeholderText="YYYY-MM-DD"
                dateFormat="yyyy/MM/dd"
                selected={endTime}
                onChange={this.handleChangeEndTime}
              />
            </Col>
          </Row>
          <Row>
            <Col lg="3" md="3" sm="3" xs="12" className="mt-1">
              <Input
                type="select"
                onChange={this.handleChange("filterBy")}
                name="select"
                id="exampleSelect"
                className="mr-2 selectGroup"
              >
                <option>Filter list</option>
                <option>Business Member Id</option>
                <option>GBT greater</option>
                <option>GBT greater or equal</option>
                <option>GBT smaller</option>
                <option>GBT smaller or equal</option>
                <option>Full Name</option>
              </Input>
            </Col>
            <Col lg="3" md="3" sm="3" xs="12" className="mt-1">
              <Input
                type="text"
                onChange={this.handleChange("keyWord")}
                name="text"
                id="search"
                className="brs"
                placeholder={t("TopUpPage.KeyWord")}
              ></Input>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col lg="4" md="4" sm="4" xs="12" className="mt-1">
              <Button
                outline
                color="secondary"
                className="custom-btn mr-4 mt-1"
                disabled={
                  this.props.status === ACTIONS.SEARCH_CHARGE_PROGRESS ||
                  !startTime ||
                  !endTime ||
                  checkDate
                }
                onClick={this.handleSearchData}
              >
                {this.props.status === ACTIONS.SEARCH_CHARGE_PROGRESS && (
                  <CircularProgress className="mr-2" size={20} />
                )}
                {t("Button.Search")}
              </Button>
              <Workbook
                filename="TopUpPage.xlsx"
                element={
                  <Button
                    outline
                    color="secondary"
                    className="custom-btn mt-1"
                    disabled={
                      this.props.status !== ACTIONS.SEARCH_CHARGE_SUCCESS ||
                      !Array.isArray(charges) ||
                      charges.length === 0
                    }
                  >
                    {t("Button.CSVExport")}
                  </Button>
                }
              >
                <Workbook.Sheet data={charges} name="Sheet A">
                  <Workbook.Column label="No." value="no" />
                  <Workbook.Column
                    label="businessMemberId"
                    value="businessMemberId"
                  />
                  <Workbook.Column
                    label="Passport Number"
                    value="passportNumber"
                  />
                  <Workbook.Column label="Full Name" value="fullname" />
                  <Workbook.Column label="GBT Amount" value="GBTAmount" />
                  <Workbook.Column label="Top Up Amount" value="topUpAmount" />
                  <Workbook.Column label="GBT Ezp Fee" value="ezpFeeGBT" />
                  <Workbook.Column
                    label="GBT Excel Finance Fee"
                    value="excelFeeGBT"
                  />
                  <Workbook.Column
                    label="Times request in Day"
                    value="dayCharge"
                  />
                  <Workbook.Column
                    label="Times request in Month"
                    value="monthCharge"
                  />
                  <Workbook.Column label="Created At" value="timestamps" />
                </Workbook.Sheet>
              </Workbook>
            </Col>
          </Row>
          {this.renderTable()}
        </div>
        {[
          ACTIONS.GET_CHARGE_FAIL,
          ACTIONS.SEARCH_CHARGE_FAIL,
          ACTIONS.REJECT_CHARGE_FAIL,
          ACTIONS.APPROVAL_CHARGE_FAIL
        ].indexOf(this.props.status) >= 0 &&
          !this.state.alertAck && (
            <Alert
              title={t("Alert.Error")}
              content={this.props.error.code}
              okTitle={t("Alert.OK")}
              onOK={() => {
                this.setState({ alertAck: true, tickCharges: [] });
              }}
            />
          )}
        {[
          ACTIONS.REJECT_CHARGE_SUCCESS,
          ACTIONS.APPROVAL_CHARGE_SUCCESS
        ].indexOf(this.props.status) >= 0 &&
          !this.state.alertAck && (
            <Alert
              title={t("Alert.Success")}
              content={t("Alert.ChangedStatus")}
              okTitle={t("Alert.OK")}
              onOK={() => {
                this.setState({ alertAck: true, tickCharges: [] });
              }}
            />
          )}
        {this.state.isReBalance && (
          <Alert
            title={t("Alert.ConfirmMessage")}
            content={t("Alert.WantUpdateRequest")}
            okTitle={t("Alert.OK")}
            cancelTitle={t("Alert.Cancel")}
            onOK={() => {
              this.setState({ isReBalance: false });
              this.alertAck();
              this.props.handleReBalanceCharge({
                status: STATUS_CHARGE.APPROVE,
                data: tickCharges
              });
            }}
            onCancel={() => {
              this.setState({ isReBalance: false });
            }}
          />
        )}
        {this.state.isReject && (
          <Alert
            title={t("Alert.ConfirmMessage")}
            content={t("Alert.WantRejectCharges")}
            okTitle={t("Alert.OK")}
            cancelTitle={t("Alert.Cancel")}
            onOK={() => {
              this.setState({ isReject: false });
              this.alertAck();
              this.props.handleRejectCharge({
                status: STATUS_CHARGE.REJECT,
                data: tickCharges
              });
            }}
            onCancel={() => {
              this.setState({ isReject: false });
            }}
          />
        )}
        {Array.isArray(charges) && charges.length > 0 && (
          <div className="d-flex justify-content-between align-content-center align-items-center charge-request-list-content">
            <ReactPaginate
              previousLabel={"<"}
              nextLabel={">"}
              breakLabel={<a href="">...</a>}
              breakClassName={"break-me"}
              pageCount={this.props.pages}
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={this.handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
            />
            <div>
              <Button
                variant="contained"
                disabled={
                  this.props.status === ACTIONS.REJECT_CHARGE_PROGRESS ||
                  (tickCharges && tickCharges.length === 0)
                }
                className="submit-btn mr-2"
                onClick={() => {
                  this.setState({ isReject: true });
                }}
              >
                {this.props.status === ACTIONS.REJECT_CHARGE_PROGRESS && (
                  <CircularProgress className="mr-2" size={20} />
                )}
                <span>{t("Button.RejectRequest")}</span>
              </Button>
              <Button
                variant="contained"
                disabled={
                  this.props.status === ACTIONS.APPROVAL_CHARGE_PROGRESS ||
                  (tickCharges && tickCharges.length === 0)
                }
                className="submit-btn"
                onClick={() => {
                  this.setState({ isReBalance: true });
                }}
              >
                {this.props.status === ACTIONS.APPROVAL_CHARGE_PROGRESS && (
                  <CircularProgress className="mr-2" size={20} />
                )}
                <span>{t("Button.UpdateRequest")}</span>
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    status: state.charge.status,
    error: state.charge.error,
    charges: state.charge.charges,
    pages: state.charge.pages
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetChargeRequest: data => {
      dispatch(getChargeRequest(data));
    },
    handleRejectCharge: data => {
      dispatch(rejectCharge(data));
    },
    handleReBalanceCharge: data => {
      dispatch(approvalCharge(data));
    },
    chargeSearch: data => {
      dispatch(chargeSearch(data));
    }
  };
};

export default withNamespaces()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ChargeRequestList)
);
